import React, { useCallback } from "react";
import { socket } from "../../../../lib/socketio";
import { GroupTemplate } from "../../../Definitions/cl";
import { Grid, Label } from "semantic-ui-react";
import IOColumn from "../../../Monitor/Data/IOColumn";
import ActivateOverride from "../../../Macros/ActivateOverride";
import Footer from "../../Footer";
import ClearOverride from "../../../Macros/ClearOverride";

import { useSelector, useDispatch } from "react-redux";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import { setUser } from "../../../../actions/navActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { useLocation } from "react-router-dom";
import { IO_WRITE, isAuthorized } from "../../../../lib/authorization";

const AnalogIo_PSM4 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [ovrdata, setOvrdata] = React.useState([]);
  const [tempoverridden, settempoverriden] = React.useState({});
  const [tempovrdata, settempovrdata] = React.useState({});
  const [isCopied, setIsCopied] = React.useState(false);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 118 }, { display_id: 130 }]);
      socket.on("receive tag names", (data) => {
        data.tags_data.sort((a, b) =>
          a.tag_display_name.localeCompare(b.tag_display_name),
        ); // update 2.4.1 대소문자 구분 내림차순 정렬 (소문자 먼저)
        settags(data.tags_data);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);

  const FooterTags = tags.flatMap((t) => (t.display_id === 130 ? [t] : []));
  FooterTags.sort(
      (a, b) => a.id - b.id,
  );

  const GenTags = tags.flatMap((t) => (t.display_id === 118 ? [t] : []));
  const display = GenTags.map((t) => t.page_name);

  const AnalogTags = GroupTemplate(GenTags, "tag_display_subgroup");
  const ClearIds = Object.keys(AnalogTags[0]).map((i) =>
    AnalogTags[0][i].map((r) => r.id),
  );

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const parentcallback = useCallback((flag) => {
    if (flag === true) {
      setOvrdata([]);
      setIsCopied(false);
      settags([]);
    }
  }, []);

  const rows = 1;
  const columns = [];
  const length = AnalogTags[0].length; // * subgroup 갯수
  let i = 0;
  while (i < length) {
    columns.push(AnalogTags[0].slice(i, i + rows));
    i += rows;
  }

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <p
        style={{ alignSelf: "flex-end", marginBottom: "0px", color: "#AAAAAA" }}
      >
        AIN
        <Label
          circular
          horizontal
          empty
          size="tiny"
          color="teal"
          style={{ marginLeft: "5px" }}
        />
        / AOUT
        <Label
          circular
          horizontal
          empty
          size="tiny"
          style={{ marginLeft: "5px", backgroundColor: "#008F9A" }}
        />
      </p>
      <span
        style={{
          alignSelf: "flex-end",
          color: data[21383] === 1 ? "red" : "green",
        }}
      >
        {" "}
        PCS COMMFAULT: {data[21383]}
      </span>
      {/* <span style = {{alignSelf: 'flex-end', color: data[42400]=== 1 ? 'red': 'green'}}> SVM COMMFAULT: {data[42400]}</span> */}
      <span
        style={{
          alignSelf: "flex-end",
          color: data[34809] === 1 ? "red" : "green",
        }}
      >
        {" "}
        BLO110 COMMFAULT: {data[34809]}
      </span>
      <span
        style={{
          alignSelf: "flex-end",
          color: data[34810] === 1 ? "red" : "green",
        }}
      >
        {" "}
        BLO380 COMMFAULT: {data[34810]}
      </span>
      {/* <span style = {{alignSelf: 'flex-end', color: data[42403]=== 1 ? 'red': 'green'}}> FPC COMMFAULT: {data[42403]}</span>  */}
      <p
        style={{ alignSelf: "flex-end", color: "yellow", marginBottom: "0px" }}
      >
        {" "}
        0 or 1 means communication successfully established
      </p>
      <div style={styles.div}>
        <h1>{display[0]} </h1>
        {(electronApp || isAuthorized(user.hmi_role, IO_WRITE)) && (
          <div style={styles.menu}>
            <ClearOverride
              tagid={ClearIds[0]}
              tags={tags}
              settags={settags}
              option={1}
              channel={"Clear All PSM4 Analog Overrides"}
              settempovrdata={settempovrdata}
              settempoverriden={settempoverriden}
              parentCallback={parentcallback}
            />
            <ActivateOverride
              ovrdata={ovrdata}
              tags={tags}
              settags={settags}
              channel={"Activate All PSM4 Analog Overrides"}
              parentCallback={parentcallback}
              settempovrdata={settempovrdata}
              tempoverridden={tempoverridden}
              settempoverriden={settempoverriden}
            />
          </div>
        )}
        <Grid inverted divided centered columns="equal" style={styles.grid}>
          {columns.map((c, i) => (
            <IOColumn
              key={i}
              index={i}
              column={c}
              data={data}
              title={"Analog Override"}
              ovrdata={ovrdata}
              tags={tags}
              settags={settags}
              tempovrdata={tempovrdata}
              settempovrdata={settempovrdata}
              tempoverridden={tempoverridden}
              settempoverriden={settempoverriden}
              isCopied={isCopied}
              setIsCopied={setIsCopied}
              parentCallback={parentcallback}
            />
          ))}
        </Grid>
        <Footer tags={FooterTags} data={data} />
      </div>
    </>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  toggle: {
    marginTop: "5px",
  },
  grid: {
    marginTop: "10px",
    paddingBottom: "0",
  },
  menu: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingBottom: "8px",
  },
};

export default AnalogIo_PSM4;
